var _style, _polygon, _path, _polygon2, _path2, _path3, _g, _path4, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.mail .st0{fill:none;}\n\t.mail .st1{fill:url(#SVGID_1_);}\n\t.mail .st2{fill:#CECECE;}\n\t.mail .st3{fill:url(#SVGID_00000134949798239950438610000004740902509076689557_);}\n\t.mail .st4{fill:url(#SVGID_00000001664414882939135860000006367366819095822249_);}\n\t.mail .st5{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "mail"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.9,12.38 27.54,12.12 25.24,10.63 25.24,10.67  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.64,27.84c0,0.39,0.13,0.76,0.36,1.07l0,0C1.77,28.6,1.64,28.23,1.64,27.84z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.98,21.88 12.98,21.88 2.83,15.39 1.64,14.62 2.83,15.39  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.51,10.75l0-0.02l-1.1,0.7c-0.05,0.03-0.08,0.07-0.14,0.08l0.01,0.01l-0.01,0.02L6.51,10.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.5593,
    y1: 17.233,
    x2: 32.5734,
    y2: 26.247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.15,28.44l0.76,0.48c0.24-0.33,0.35-0.87,0.35-1.07V14.62l-11.34,7.26L29.15,28.44z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "5.28,11.53 4.65,11.93 2.52,13.29 2.15,13.53 6.46,16.29 6.46,15.81 6.51,10.75 5.27,11.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "29.36,13.29 27.54,12.12 27.9,12.38 25.24,10.67 25.14,15.99 25.13,16.48 29.74,13.53  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023978147027633894500000008643600265649542531_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.823,
    y1: 17.0837,
    x2: 8.4787,
    y2: 26.3854
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023978147027633894500000008643600265649542531_)"
    },
    d: "M3.65,27.85l9.33-5.97l-10.15-6.5 l-1.19-0.76v13.22c0,0.39,0.13,0.76,0.36,1.07L3.65,27.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160895383800018474140000006332514611362597514_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.5399,
    y1: 23.196,
    x2: 22.3488,
    y2: 36.0049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160895383800018474140000006332514611362597514_)"
    },
    d: "M14.67,22.96l-0.28-0.18 c-0.02-0.01-0.04-0.02-0.05-0.03l-0.25-0.16L3.14,29.6c0.1,0.02,0.19,0.03,0.29,0.03h25.04c0.1,0,0.19-0.01,0.29-0.03L17.8,22.59 l-0.25,0.16c-0.27,0.17-0.57,0.29-0.87,0.37c-0.26,0.1-0.54,0.17-0.82,0.17C15.45,23.29,15.03,23.18,14.67,22.96z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7.56,17.08l7.7,4.94c0.38,0.23,0.87,0.22,1.25-0.02l7.5-4.76l0.22-12.46c0-0.13-0.05-0.26-0.14-0.35 C24,4.33,23.88,4.28,23.75,4.28H8.16c-0.26,0-0.48,0.21-0.49,0.48L7.56,17.08z M15.89,16.43h-5.56c-0.31,0-0.55-0.25-0.55-0.55 s0.25-0.55,0.55-0.55h5.56c0.31,0,0.55,0.25,0.55,0.55S16.2,16.43,15.89,16.43z M10.33,13.76c-0.31,0-0.55-0.25-0.55-0.55 s0.25-0.55,0.55-0.55h11.13c0.31,0,0.55,0.25,0.55,0.55s-0.25,0.55-0.55,0.55H10.33z M21.45,11.08H10.33 c-0.31,0-0.55-0.25-0.55-0.55s0.25-0.55,0.55-0.55h11.13c0.31,0,0.55,0.25,0.55,0.55S21.76,11.08,21.45,11.08z M21.45,8.41H10.33 c-0.31,0-0.55-0.25-0.55-0.55s0.25-0.55,0.55-0.55h11.13c0.31,0,0.55,0.25,0.55,0.55S21.76,8.41,21.45,8.41z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.17,13.03l-2.22-1.42l-2.41-1.49c0,0,0,0,0,0l-1.27-0.79l0.08-4.54c0.01-0.43-0.15-0.84-0.46-1.15 c-0.3-0.31-0.71-0.48-1.14-0.48H8.16c-0.86,0-1.58,0.7-1.6,1.57L6.52,9.38l-1.11,0.69c-0.01-0.01-0.11,0.07-0.12,0.06l-0.69,0.43 c0,0-0.24,0.13-0.24,0.14l-3.65,2.34c-0.17,0.11-0.27,0.3-0.27,0.5v14.31c0,1.65,1.34,2.98,2.98,2.98h25.04 c1.65,0,2.98-1.34,2.98-2.98V13.53C31.44,13.33,31.34,13.14,31.17,13.03z M25.14,15.99l0.09-5.32l0-0.04l2.3,1.49l1.83,1.17 l0.38,0.24l-4.61,2.95L25.14,15.99z M7.68,4.75C7.68,4.49,7.9,4.28,8.16,4.28h15.58c0.13,0,0.26,0.05,0.35,0.15 c0.09,0.09,0.14,0.22,0.14,0.35l-0.22,12.46L16.51,22c-0.38,0.25-0.88,0.25-1.25,0.02l-7.7-4.94L7.68,4.75z M2.52,13.29l2.13-1.36 l0.62-0.4l-0.01-0.01c0.06-0.01,0.09-0.05,0.14-0.08l1.1-0.7l0,0.02l-0.05,5.06l0,0.48l-4.31-2.76L2.52,13.29z M1.64,27.84V14.62 l1.19,0.76l10.15,6.5h0l-9.33,5.97L2,28.91C1.77,28.6,1.64,28.23,1.64,27.84z M28.46,29.63H3.43c-0.1,0-0.19-0.01-0.29-0.03 l10.95-7.01l0.25,0.16c0.02,0.01,0.04,0.02,0.05,0.03l0.28,0.18c0.37,0.22,0.78,0.34,1.2,0.34c0.28,0,0.55-0.07,0.82-0.17 c0.3-0.08,0.6-0.2,0.87-0.37l0.25-0.16l10.95,7.01C28.66,29.62,28.56,29.63,28.46,29.63z M30.25,27.84c0,0.2-0.04,0.41-0.11,0.6 c-0.06,0.17-0.15,0.33-0.26,0.47l-0.74-0.47l-10.24-6.55l11.34-7.26V27.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.33,8.41h11.13c0.31,0,0.55-0.25,0.55-0.55S21.76,7.3,21.45,7.3H10.33c-0.31,0-0.55,0.25-0.55,0.55 S10.02,8.41,10.33,8.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.33,11.08h11.13c0.31,0,0.55-0.25,0.55-0.55s-0.25-0.55-0.55-0.55H10.33c-0.31,0-0.55,0.25-0.55,0.55 S10.02,11.08,10.33,11.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.33,13.76h11.13c0.31,0,0.55-0.25,0.55-0.55s-0.25-0.55-0.55-0.55H10.33c-0.31,0-0.55,0.25-0.55,0.55 S10.02,13.76,10.33,13.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.44,15.87c0-0.31-0.25-0.55-0.55-0.55h-5.56c-0.31,0-0.55,0.25-0.55,0.55s0.25,0.55,0.55,0.55h5.56 C16.2,16.43,16.44,16.18,16.44,15.87z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bd23c8b5064da104b5b8c31a364d7f77.svg";
export { ForwardRef as ReactComponent };